import { DomainRuleViolationError } from "./errors.js";
// Frozen: the database CHECK constraint is generated from this tuple.
export const conversationModes = Object.freeze([
    "AI_ACTIVE",
    "HANDOFF_REQUESTED",
    "WAITING_FOR_CONCIERGE",
    "HUMAN_ACTIVE",
]);
/** The handoff events that move, or act inside, a conversation mode. Nothing else changes a mode. */
export const conversationEvents = Object.freeze([
    "handoff.request",
    "handoff.route",
    "handoff.accept",
    "handoff.release",
    "handoff.cancel",
    "handoff.reassign",
    "handoff.transfer_owner",
]);
/** The six mode changes. The database guard (LF007) allows exactly these (from, to) pairs. */
export const conversationModeTransitions = Object.freeze([
    { event: "handoff.request", from: "AI_ACTIVE", to: "HANDOFF_REQUESTED" },
    { event: "handoff.route", from: "HANDOFF_REQUESTED", to: "WAITING_FOR_CONCIERGE" },
    { event: "handoff.accept", from: "WAITING_FOR_CONCIERGE", to: "HUMAN_ACTIVE" },
    { event: "handoff.release", from: "HUMAN_ACTIVE", to: "AI_ACTIVE" },
    { event: "handoff.cancel", from: "HANDOFF_REQUESTED", to: "AI_ACTIVE" },
    { event: "handoff.cancel", from: "WAITING_FOR_CONCIERGE", to: "AI_ACTIVE" },
]);
/** Events that happen inside a mode: the mode, the version and the generation do not change. */
export const conversationInModeEvents = Object.freeze([
    { event: "handoff.reassign", mode: "WAITING_FOR_CONCIERGE" },
    { event: "handoff.transfer_owner", mode: "HUMAN_ACTIVE" },
]);
/** Whether `from -> to` is one of the six allowed mode changes (a no-op is not a change). */
export function isAllowedConversationModeChange(from, to) {
    return conversationModeTransitions.some((row) => row.from === from && row.to === to);
}
/**
 * The only place a mode transition is decided. A model, a client or a worker never names the new
 * mode: it names the handoff event, and an event that does not apply in the current mode is
 * refused (`conversation.transition_invalid`).
 */
export function planConversationTransition(mode, event) {
    const change = conversationModeTransitions.find((row) => row.event === event && row.from === mode);
    if (change !== undefined) {
        return Object.freeze({
            event,
            from: mode,
            to: change.to,
            changesMode: true,
            incrementsGeneration: mode === "AI_ACTIVE" && change.to !== "AI_ACTIVE",
        });
    }
    if (conversationInModeEvents.some((row) => row.event === event && row.mode === mode)) {
        return Object.freeze({
            event,
            from: mode,
            to: mode,
            changesMode: false,
            incrementsGeneration: false,
        });
    }
    throw new DomainRuleViolationError("conversation.transition_invalid");
}
